import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { ImporterDashboardLoader } from '@confluence/importer-dashboard/entry-points/ImporterDashboardLoader.tsx';

export const ImporterDashboardRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <ImporterDashboardLoader />;

ImporterDashboardRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: 'IMPORTER_STATUS_DASHBOARD' },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
